import { useEffect } from 'react';

/**
 * Executes function if user mouse down outside the HTML Element ref(s).
 *
 * @param containerRef - an array of references or a single ref
 * @param onMouseDown - called if the mouseDown event occurs outside of the provided ref(s)
 * @param useCapture - optional boolean value to be passed in for the `useCapture` parameter for `addEventListener`
 */
export const useOnOutsideMouseDown = (containerRef, onOutsideMouseDown, useCapture) => {
  useEffect(() => {
    const onMouseDown = event => {
      const containerRefs = !Array.isArray(containerRef) ? [containerRef] : containerRef;
      for (const ref of containerRefs) {
        if (ref.current?.contains(event.target)) {
          return;
        }
      }
      onOutsideMouseDown();
    };
    window.addEventListener('mousedown', onMouseDown, useCapture);
    return () => {
      window.removeEventListener('mousedown', onMouseDown, useCapture);
    };
  }, [containerRef, onOutsideMouseDown, useCapture]);
};
//# sourceMappingURL=useOnOutsideMouseDown.js.map